import { RootState } from 'lib/core/data/reducer'
import { CartId } from 'lib/types'

export const getGuestEmail = (cartId: CartId) => (state: RootState) => {
  const slice = state.quote.setGuestEmail[cartId ?? ''] ?? {}
  return slice
}
